import { useCallback, useMemo } from 'react'
import SearchMultiselect, { IOption } from '../../../../components/SearchMultiselect'
import { IFiltersData } from '../SearchQuestionsContent/types'
import { SelectLabels, TSelectName, TSelected, createOption } from './data'
import { SelectsContainer } from './styles'
import { useGetFiltersData } from '../../hooks/use-get-filters-data'
import { useGetThemesAndTopics } from '../../hooks/use-get-themes-and-topics'
import Checkbox from '../../../../components/Checkbox'

interface IProps {
  selected: TSelected
  onSelectChange: (selectName: TSelectName) => (value: IOption[]) => void

  canceledValue: boolean
  commentedValue: boolean
  onCanceledChange: (value: boolean) => void
  onCommentedChange: (value: boolean) => void
}

const Selects = (props: IProps) => {
  const { data: filtersData } = useGetFiltersData()
  const { data: themesAndTopics } = useGetThemesAndTopics(props.selected.subjects)

  const options: Record<keyof IFiltersData, IOption[]> = useMemo(
    () => ({
      evaluatingInstitutions: createOption(filtersData, 'evaluatingInstitutions'),
      graduation: createOption(filtersData, 'graduation'),
      roles: createOption(filtersData, 'roles'),
      schooling: createOption(filtersData, 'schooling'),
      subjects: createOption(filtersData, 'subjects'),
      years: createOption(filtersData, 'years'),
      publicTenders: createOption(filtersData, 'publicTenders'),
    }),
    [filtersData]
  )

  const getThemesOptions = useCallback(
    () => createOption(themesAndTopics, 'themes'),
    [themesAndTopics]
  )

  // const getTopicsOptions = useCallback(
  //   () => createOption(themesAndTopics, 'topics'),
  //   [themesAndTopics]
  // )

  return (
    <SelectsContainer>
      <SearchMultiselect
        selected={props.selected.subjects}
        onChange={props.onSelectChange('subjects')}
        label={SelectLabels['subjects']}
        options={options['subjects']}
      />
      <SearchMultiselect
        selected={props.selected.themes}
        onChange={props.onSelectChange('themes')}
        label={SelectLabels['themes']}
        options={getThemesOptions()}
      />
      <SearchMultiselect
        selected={props.selected.roles}
        onChange={props.onSelectChange('roles')}
        className="input"
        label={SelectLabels['roles']}
        options={options['roles']}
      />
      <SearchMultiselect
        selected={props.selected.years}
        onChange={props.onSelectChange('years')}
        className="input"
        label={SelectLabels['years']}
        options={options['years']}
      />
      <SearchMultiselect
        selected={props.selected.evaluatingInstitutions}
        onChange={props.onSelectChange('evaluatingInstitutions')}
        className="input"
        label={SelectLabels['evaluatingInstitutions']}
        options={options['evaluatingInstitutions']}
      />
      <SearchMultiselect
        selected={props.selected.publicTenders}
        onChange={props.onSelectChange('publicTenders')}
        className="input"
        label={SelectLabels['publicTenders']}
        options={options['publicTenders']}
      />
      <SearchMultiselect
        selected={props.selected.graduation}
        onChange={props.onSelectChange('graduation')}
        className="input hide-in-simple-mode"
        label={SelectLabels['graduation']}
        options={options['graduation']}
      />
      <SearchMultiselect
        selected={props.selected.questionType}
        onChange={props.onSelectChange('questionType')}
        className="input hide-in-simple-mode"
        label={SelectLabels['questionType']}
        options={QuestionTypeOptions}
        hideSearchBar
      />

      <div className="canceled-checkbox hide-in-simple-mode">
        <p className="title">Exibir questões:</p>
        <div className="checkbox-group">
          <Checkbox
            className="checkbox"
            value={props.canceledValue}
            onChange={props.onCanceledChange}
          >
            Anuladas
          </Checkbox>
          <Checkbox
            className="checkbox"
            value={props.commentedValue}
            onChange={props.onCommentedChange}
          >
            Comentadas
          </Checkbox>
        </div>
      </div>

      {/* <SearchMultiselect
        selected={props.selected.topics}
        onChange={props.onChange('topics')}
        className="input"
        label={SelectLabels['topics']}
        options={getTopicsOptions()}
      />
      <SearchMultiselect
        selected={props.selected.schooling}
        onChange={props.onChange('schooling')}
        className="input hide-in-simple-mode"
        label={SelectLabels['schooling']}
        options={getOptions('schooling')}
      /> */}
    </SelectsContainer>
  )
}

const QuestionTypeOptions: IOption[] = [
  {
    label: 'Certo ou errado',
    value: 'right-wrong',
  },
  {
    label: 'Múltipla escolha - 4 alternativas',
    value: '4-alternatives',
  },
  {
    label: 'Múltipla escolha - 5 alternativas',
    value: '5-alternatives',
  },
]

export default Selects
